<template>
  <div>
    <div class="ibox float-e-margins">
      <pbn-header></pbn-header>
      <pbn-content></pbn-content>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { PBN_SET } from '../../../store/mutation-types'

import Header from './Single/Header'
import Content from './Single/Content'

export default {
  data () {
    return {
    }
  },
  components: {
    pbnHeader: Header,
    pbnContent: Content
  },
  watch: {
    $route (to, from) {
      this.loadPbn()
    }
  },
  mounted () {
    if (!this.filters.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loadPbn()
  },
  methods: {
    loadPbn () {
      axios.get('/pbn/site/' + this.$route.params.domain)
        .then(r => {
          this.activeComp = 'Setup'
          this.$store.commit(PBN_SET, r.data)
          document.title = r.data.domain + ' :: PBN360 by Aphex Media'
        })
        .catch(e => {
        })
    }
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      filters: 'getFilters'
    })
  }
}
</script>
<style>
.green {
  color: green;
}
.orange {
  color: orange;
}
.red {
  color: red;
}
.yellow {
  color: orange;
}

tr.completed td {
  background-color: #ecffec;
  color: green;
}
tr.waiting td {
  background-color: rgb(242 242 242);
  color: red;
}

tr.started td {
  background-color: #fffdf7;
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Pbn.vue